<div id="campaigns" #campaigns>
    <router-outlet></router-outlet>
</div>
